import * as React from 'react';
import { IconChevronLeft16 } from '@cian/ui-kit/icons';
import * as styles from './GradientArrowLeft.css';
import { GRADIENT_ARROW_WIDTH } from '../../constants/arrows';

interface IGradientArrowRightProps {
  onClick(): void;
}

export const GradientArrowLeft: React.FC<IGradientArrowRightProps> = ({ onClick }) => {
  return (
    <div style={{ width: `${GRADIENT_ARROW_WIDTH}px` }} className={styles['arrow']} onClick={onClick}>
      <IconChevronLeft16 color="gray_icons_100" />
    </div>
  );
};
